<template>
    <section
        class="block hero bg-img is-primary"
        :class="{ 'is-medium': isHomepage }">
        <div class="hero-head">
            <v-navbar />
        </div>
        <div class="hero-body">
            <div class="container" v-if="isHomepage">
                <h1 class="title is-2">Aleksi Hynönen</h1>
                <h1 class="subtitle is-3">Portfolio</h1>
            </div>
            <div class="container" v-else>
                <h1 class="title is-2">{{ pageTitle }}</h1>
            </div>
        </div>
        <div class="hero-foot">
            <div class="container">
                <p class="">
                    {{ $t('pic') }} <a href="https://pixabay.com/fi/users/fancycrave1-1115284/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=820275">fancycrave1</a> {{ $t('prep') }} <a href="https://pixabay.com/fi/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=820275"> {{ $t('pixabay') }}</a>
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import vNavbar from "./vNavbar";

export default {
    name: 'hero',
    props: {
        pageTitle: String
    },
    components: {
        vNavbar
    },
    watch: {
        '$route'() {
            this.isHomepage = this.$route.path === '/';
        }
    },
    data() {
        return {
            isHomepage: this.$route.path === '/'
        }
    }
}
</script>

<style lang="scss" scoped>
.bg-img {
    background-image: url("../../../assets/bg.jpg"), linear-gradient(to bottom right, rgba(0,0,0,0) 0%,rgba(255,255,255,1) 100%);
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    background-blend-mode: overlay;
    background-color: rgba(0, 0, 0, .75) !important;
}
</style>

<i18n>
{
    "en": {
        "profession": "Software developer",
        "pic": "Background image by",
        "prep": "from",
        "pixabay": "Pixabay"
    },
    "fi": {
        "profession": "Sovelluskehittäjä",
        "pic": "Taustakuva",
        "prep": " ",
        "pixabay": "Pixabaystä"
    }
}
</i18n>
